var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{on:{"click":function($event){return _vm.$emit('categoryDidSelected', _vm.category)}}},[_c('v-card-subtitle',{staticClass:"line-break pa-2 text-center"},[_vm._v(" "+_vm._s(_vm.category.name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }